module.exports = __webpack_public_path__ + "static/media/books.829df429.png";